import { render, staticRenderFns } from "./BaseDateSelect.vue?vue&type=template&id=03056013"
import script from "./BaseDateSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDateSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports